import { c as _c } from "react/compiler-runtime";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import Script from "next/script";
import type { ImageObject as ImageObjectSchema, Product as ProductSchema, WithContext } from "schema-dts";
import {
// graphqlShopifyStorefront,
readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Image_Fragment, MediaConnectionMasked_Fragment, MediaImage_Fragment, ProductOption_Fragment } from "#/graphql/shopify-storefront/fragments";
import { transformShopifyProductToAggregateOfferSchema, transformShopifyOfferToOfferSchema, transformShopifyProductVariantMaskedToSizeSpecificationSchema, transformShopifyImageToImageObjectSchema } from "../../utilities/linked-data";
import { parseGid } from "@shopify/hydrogen-react/analytics-utils";
import { LinkedData_Localization_Fragment, LinkedData_Product_Fragment, LinkedData_ProductVariant_Fragment, LinkedData_Shop_Fragment } from "#/components/linked-data/graphql";

// export const LinkedDataProductFragment = graphqlShopifyStorefront(`
//   fragment ProductLinkedData on Product {
//     ...ProductVariantLinkedData
//     id
//     productType
//     mediaConnectionMasked: media(first: 2) {
//       ...MediaConnectionMasked
//     }
//     optionsMasked: options {
//       ...ProductOption
//     }
//     title
//   }
// `, [
//   MediaConnectionMaskedFragment,
//   ProductVariantLinkedDataFragment,
//   ProductOptionFragment,
// ])

export function LinkedDataProduct(t0) {
  const $ = _c(16);
  const {
    id,
    localizationMasked,
    productMasked,
    shopMasked,
    variantMasked
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== id || $[1] !== localizationMasked || $[2] !== productMasked || $[3] !== shopMasked || $[4] !== variantMasked) {
    const shop = readFragmentShopifyStorefront(LinkedData_Shop_Fragment, shopMasked);
    const product = readFragmentShopifyStorefront(LinkedData_Product_Fragment, productMasked);
    const variant = readFragmentShopifyStorefront(LinkedData_ProductVariant_Fragment, variantMasked);
    const logoImage = readFragmentShopifyStorefront(Image_Fragment, shop.brand?.logo?.image);
    const {
      mediaConnectionMasked,
      optionsMasked
    } = product;
    const media = readFragmentShopifyStorefront(MediaConnectionMasked_Fragment, mediaConnectionMasked);
    const imagesMasked = media.edges.map(_temp).filter(_temp2).map(_temp3).filter(_temp4).map(_temp5).filter(Boolean);
    const options = optionsMasked.map(_temp6);
    const logo = {
      "@context": "https://schema.org",
      "@type": "ImageObject",
      about: shop.name,
      description: shop.brand?.logo?.alt ?? shop.brand?.logo?.alt ?? shop.name,
      height: logoImage?.height?.toString(),
      representativeOfPage: false,
      width: logoImage?.width?.toString(),
      url: logoImage?.url
    } satisfies WithContext<ImageObjectSchema>;
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Product",
      brand: product.vendor,
      color: variant.selectedOptions.find(_temp7)?.value,
      description: product.description,
      ...(variant.barcode && {
        gtin: variant.barcode
      }),
      identifier: variant.id,
      image: [...imagesMasked.map(imageMasked_0 => transformShopifyImageToImageObjectSchema({
        about: product.title,
        imageMasked: imageMasked_0
      })), logo],
      isVariantOf: {
        "@type": "ProductGroup",
        brand: {
          "@type": "Brand",
          name: product.vendor
        },
        description: product.description,
        identifier: product.id,
        name: product.title,
        offers: transformShopifyProductToAggregateOfferSchema({
          localizationMasked,
          productMasked,
          shopMasked
        }),
        productGroupID: product.id,
        url: `/products/${product.handle}`,
        ...(options && {
          variesBy: options.map(_temp8)
        })
      },
      keywords: product.tags,
      mainEntityOfPage: `/products/${product.handle}?${variant.selectedOptions.map(_temp9).join("&")}`,
      name: variant.title ?? variant.title,
      offers: transformShopifyOfferToOfferSchema({
        localizationMasked,
        productMasked,
        shopMasked,
        variantMasked
      }),
      productID: product.id,
      size: transformShopifyProductVariantMaskedToSizeSpecificationSchema({
        variantMasked
      }),
      url: `/products/${product.handle}?${variant.selectedOptions.map(_temp10).join("&")}`,
      ...(variant.weight && {
        weight: {
          "@type": "QuantitativeValue",
          unitCode: "KGM",
          value: variant.weight
        }
      })
    };
    T0 = Script;
    t1 = id ?? `LinkedDataProduct-${parseGid(variant.id).id}`;
    t2 = id ?? `LinkedDataProduct-${parseGid(variant.id).id}`;
    t3 = "application/ld+json";
    t4 = JSON.stringify(jsonLd);
    $[0] = id;
    $[1] = localizationMasked;
    $[2] = productMasked;
    $[3] = shopMasked;
    $[4] = variantMasked;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] !== T0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <T0 id={t1} key={t2} type={t3}>{t4}</T0>;
    $[10] = T0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function _temp10(selectedOption_1) {
  return `${selectedOption_1.name.toLowerCase()}=${selectedOption_1.value.toLowerCase()}`;
}
function _temp9(selectedOption_0) {
  return `${selectedOption_0.name.toLowerCase()}=${selectedOption_0.value.toLowerCase()}`;
}
function _temp8(option) {
  return option.name;
}
function _temp7(selectedOption) {
  return selectedOption.name === "Color";
}
function _temp6(optionMasked) {
  return readFragmentShopifyStorefront(ProductOption_Fragment, optionMasked);
}
function _temp5(t0) {
  const {
    imageMasked
  } = t0;
  return imageMasked;
}
function _temp4(medium_0) {
  return medium_0.__typename === "MediaImage";
}
function _temp3(mediumMasked_0) {
  return readFragmentShopifyStorefront(MediaImage_Fragment, mediumMasked_0);
}
function _temp2(medium) {
  return medium.__typename === "MediaImage";
}
function _temp(t0) {
  const {
    node: mediumMasked
  } = t0;
  return mediumMasked;
}